<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName">
				<FormItem prop="Name">
					<Input style="width: 200px;" type="text" v-model="formInline.Name" placeholder="型号名称">
					<span slot="prepend">型号名称</span>
					</Input>
				</FormItem>
				<FormItem prop="TitleName">
					<Input style="width: 200px;" type="text" v-model="formInline.TitleName" placeholder="型号描述">
					<span slot="prepend">型号描述</span>
					</Input>
				</FormItem>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<div style="float: right;">
				<Button type="primary" @click="show('add')" v-if="hasWidgets('add')">型号添加</Button>
				<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">批量导入</Button> -->
			</div>
		</Form>
		<!-- <Table :columns="columns1" :data="data1" :height="tableHeight" size="small">
			<MyPage slot="footer" ref="sonPage" :param="pageParam" :url="getOperatorInfoUrl" @listData='getDeviceData'></MyPage>
		</Table> -->
		<PageTable ref="table" :columns="columns1" :tableHeight="tableHeight" :url="getModelListUrl"
			:queryParam="pageParam"></PageTable>
		<Modal :mask-closable="false" v-model="modalView" :title="modal.Title" width="60%">
			<!--安装和修改-->
			<Form label-position="right" :rules="ruleInline"
				v-if="modal.type=='add'||modal.type=='update'||modal.type=='view'" ref="AddUpForm" :model="StationForm"
				:label-width="120">
				<Row>
					<Col span="12">
					<FormItem label="型号名称" prop="ModelId">
						<Input :disabled="ifup" v-model="StationForm.ModelId" placeholder="输入型号名称"></Input>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="型号描述" prop="ModelDesc">
						<Input :disabled="ifViewStation" v-model="StationForm.ModelDesc" placeholder="输入型号描述"></Input>
					</FormItem>
					</Col>
					<Divider orientation="left" size="small" style="color: lightgray;">充电桩信息</Divider>
					<Col span="12">
					<FormItem label="设备类型" prop="EquipmentType">
						<Select :disabled="ifViewStation" placeholder="输入设备类型" v-model="StationForm.EquipmentType">
							<Option :value="1">直流设备</Option>
							<Option :value="2">交流设备</Option>
							<Option :value="3">交直流一体设备</Option>
							<Option :value="4">无线设备</Option>
							<Option :value="5">其他</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="充电枪数量" prop="ConnectorNum">
						<Input :disabled="ifViewStation" v-model="StationForm.ConnectorNum" placeholder=""></Input>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="总功率" prop="TotolPower">
						<Input :disabled="ifViewStation" v-model="StationForm.TotolPower" placeholder=""></Input>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="额定功率" prop="EquipmentPower">
						<Input :disabled="ifViewStation" v-model="StationForm.EquipmentPower" placeholder=""></Input>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="最小输出电流" prop="MinOutputCurrent">
						<Input :disabled="ifViewStation" v-model="StationForm.MinOutputCurrent" placeholder=""></Input>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="最大输出电流" prop="MaxOutputCurrent">
						<Input :disabled="ifViewStation" v-model="StationForm.MaxOutputCurrent" placeholder=""></Input>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="最小输出电压" prop="MinOutputVoltage">
						<Input :disabled="ifViewStation" v-model="StationForm.MinOutputVoltage" placeholder=""></Input>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="最大输出电压" prop="MaxOutputVoltage">
						<Input :disabled="ifViewStation" v-model="StationForm.MaxOutputVoltage" placeholder=""></Input>
					</FormItem>
					</Col>
					<Col span="24">
					<FormItem label="适用车型" prop="AdapteCar">
						<Input :disabled="ifViewStation" v-model="StationForm.AdapteCar" placeholder=""></Input>
					</FormItem>
					</Col>
					<Divider orientation="left" size="small" style="color: lightgray;">充电枪信息</Divider>
					<Col span="12">
					<FormItem label="支持标准版本" prop="NationalStandard">
						<Select :disabled="ifViewStation" placeholder="支持标准版本" v-model="StationForm.NationalStandard">
							<Option :value="1">国标2011版</Option>
							<Option :value="2">国标2015版</Option>
							<Option :value="3">大功率交流</Option>
							<Option :value="255">其它</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="充电枪类型" prop="ConnectorType">
						<Select :disabled="ifViewStation" placeholder="输入充电枪类型" v-model="StationForm.ConnectorType">
							<Option :value="1">家用插座</Option>
							<Option :value="2">交流接口插座</Option>
							<Option :value="3">交流接口插头</Option>
							<Option :value="4">直流接口插头</Option>
							<Option :value="5">无线充电座</Option>
							<Option :value="100">其他</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="枪辅源类型" prop="ConnectorBmsPowerType">
						<Select :disabled="ifViewStation" placeholder="输入充电枪类型" v-model="StationForm.ConnectorBmsPowerType">
							<Option :value="1">12V</Option>
							<Option :value="2">24V</Option>
							<Option :value="3">自适应</Option>
							<Option :value="255">其他</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="枪最低输出电压" prop="ConnectorVoltageLowerLimits">
						<Input :disabled="ifViewStation" v-model="StationForm.ConnectorVoltageLowerLimits" placeholder=""></Input>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="枪最高输出电压" prop="ConnectorVoltageUpperLimits">
						<Input :disabled="ifViewStation" v-model="StationForm.ConnectorVoltageUpperLimits" placeholder=""></Input>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="枪额定功率" prop="ConnectorPower">
						<Input :disabled="ifViewStation" v-model="StationForm.ConnectorPower" placeholder=""></Input>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="枪额定电压" prop="ConnectorVoltage">
						<Input :disabled="ifViewStation" v-model="StationForm.ConnectorVoltage" placeholder=""></Input>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="枪额定电流" prop="ConnectorCurrent">
						<Input :disabled="ifViewStation" v-model="StationForm.ConnectorCurrent" placeholder=""></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div v-if="modal.type=='add'" slot="footer">
				<Button v-if="modal.type!='install'" type="warning" size="large" @click="modalCancel">重置</Button>
				<Button type="success" size="large" @click="modalOk('add')">新增</Button>
			</div>
			<div v-if="modal.type=='update'" slot="footer">
				<Button type="success" size="large" @click="modalOk('up')">确认修改</Button>
			</div>
			<div v-if="modal.type=='view'" slot="footer">
			</div>
		</Modal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import PageTable from '../../public/PageTable/PageTable.vue';
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		components: {
			PageTable
		},
		data() {
			return {
				getModelListUrl: webapi.base_api_url + '/Archives/GetEquipmentModels',
				// uploadImageUrl: webapi.base_api_url + '/Common/UploadImage',
				zindex: 2000,
				loadingStatus: false,
				params: "", //table 传参
				tableHeight: "650",
				modal: {
					Title: "设备型号添加",
					type: "addOperator"
				},
				//修改添加moda
				modalView: false,
				//字段显示
				ifAddStation: true,
				//修改不能修改id
				ifup: false,
				//场站信息是否只能查看
				ifViewStation: false,
				//档案-场站管理全部信息
				StationForm: {
					ModelId: '',
					ModelDesc: '',
					ConnectorNum: 1,
					EquipmentType: 1,
					TotolPower: 0,
					EquipmentPower: 0,
					MinOutputCurrent: 0,
					MaxOutputCurrent: 0,
					MinOutputVoltage: 0,
					MaxOutputVoltage: 0,
					NationalStandard: 2,
					AdapteCar: '',
					ConnectorType: 4,
					ConnectorBmsPowerType: 3,
					ConnectorVoltageLowerLimits: 0,
					ConnectorVoltageUpperLimits: 0,
					ConnectorPower: 0,
					ConnectorVoltage: 0,
					ConnectorCurrent: 0,
				},
				//校验字段
				ruleInline: {
					ModelId: [{
						required: true,
						message: '型号名称',
						trigger: 'blur'
					}],
					ModelDesc: [{
						required: true,
						message: '型号描述',
						trigger: 'blur'
					}],
				},
				BreadcrumbList: ['档案管理', '>>', '设备型号管理'],
				formInline: {
					Name: '',
					TitleName: '',
				},
				//table标题数据
				columns1: [{
						title: '型号名称',
						key: 'ModelId',
						minWidth: 120,
					}, {
						title: '型号描述',
						key: 'ModelDesc',
						minWidth: 100,
					},
					{
						title: '设备类型',
						key: 'EquipmentType',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.EquipmentTypeDesc)
						}
					}, {
						title: '充电枪数量',
						key: 'ConnectorNum',
						minWidth: 100,
					}, {
						title: '总功率',
						key: 'TotolPower',
						minWidth: 100,
					}, {
						title: '额定功率',
						key: 'EquipmentPower',
						minWidth: 100,
					}, {
						title: '最小输出电流',
						key: 'MinOutputCurrent',
						minWidth: 110,
					}, {
						title: '最大输出电流',
						key: 'MaxOutputCurrent',
						minWidth: 110,
					}, {
						title: '最小输出电压',
						key: 'MinOutputVoltage',
						minWidth: 110,
					}, {
						title: '最大输出电压',
						key: 'MaxOutputVoltage',
						minWidth: 110,
					}, {
						title: '支持标准类型',
						key: 'NationalStandard',
						minWidth: 110,
						render: (h, params) => {
							return h('div', params.row.NationalStandardDesc)
						}
					},
					{
						title: '适用车型',
						key: 'AdapteCar',
						minWidth: 100,
					},
					{
						title: '充电枪类型',
						key: 'ConnectorType',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.ConnectorTypeDesc)
						}
					},
					{
						title: '辅源类型',
						key: 'ConnectorBmsPowerType',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.ConnectorBmsPowerTypeDesc)
						}
					},
					{
						title: '充电枪最低输出电压',
						key: 'ConnectorVoltageLowerLimits',
						minWidth: 100,
					},
					{
						title: '充电枪最高输出电压',
						key: 'ConnectorVoltageUpperLimits',
						minWidth: 100,
					},
					{
						title: '充电枪额定功率',
						key: 'ConnectorPower',
						minWidth: 100,
					},
					{
						title: '充电枪额定电压',
						key: 'ConnectorVoltage',
						minWidth: 100,
					},
					{
						title: '充电枪额定电流',
						key: 'ConnectorCurrent',
						minWidth: 100,
					},
					{
						title: '操作',
						key: 'action',
						width: 135,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("update", params.row)
										}
									}
								}, '修改') : h(),
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										//为了不误操作，确定取消相反
										click: () => {
											this.show("view", params.row)
										}
									}
								}, '查看') : h(),
							]);
						}
					}
				],
				data1: [],
				payValue: 0
			};
		},
		created() {
			const _this = this;
			_this.getTableHeight()
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					Name: _this.formInline.Name,
					TitleName: _this.formInline.TitleName
				}
				return param
			},
		},
		methods: {
			...mapActions([
				'GetTypeListDefine',
			]),
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//操作
			show: function(type, params) {
				switch (type) {
					case "add":
						this.modal.type = "add";
						this.modal.Title = "设备型号添加";
						this.ifup = false
						this.ifViewStation = false;
						this.ifAddStation = true;
						this.modalCancel();
						break;
					case "update":
						this.modal.type = "update";
						this.modal.Title = "设备型号修改";
						this.ifup = true
						this.$nextTick(() => {
							this.getUpdateMessage(params);
						})
						this.ifViewStation = false;
						this.ifAddStation = false;
						break;
					case "view":
						this.modal.type = "view";
						this.modal.Title = "设备型号查看";
						this.$nextTick(() => {
							this.getUpdateMessage(params);
						})
						this.ifViewStation = true
						this.ifAddStation = false;
						this.ifup = true
						break;
				}
				this.modalView = true;
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				// this.$refs.sonPage.getList();
				this.$refs.table.getData();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160 - (window.innerWidth < 722 ? 40 : 0);
			},
			modalCancel: function() {
				this.uploadList = []
				this.StationPicturesArray = []
				this.$nextTick(() => {
					this.$refs.AddUpForm.resetFields();
					console.log(this.$refs.AddUpForm);
				})
			},
			getUpdateMessage: function(equipModel) {
				console.log("修改查看设备型号方法" + equipModel.ModelId);
				const _this = this;
				// for (let i = 0; i < _this.data1.length; i++) {
				// 	if (_this.data1[i].ModelId == ModelId) {
				// 		_this.StationForm = Object.assign({}, _this.data1[i])
				// 	}
				// }
				_this.StationForm = Object.assign({}, equipModel);
			},
			//新增||修改
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case "add":
						_this.StationForm.IsEdit = false
						break;
					case "up":
						_this.StationForm.IsEdit = true
						break;
				}

				const param = _this.StationForm
				_this.$refs.AddUpForm.validate((valid) => {
					console.log("设备型号" + type + "----" + valid)
					if (valid) {
						_this.$axios.post(webapi.base_api_url + (type == 'add' ? '/Archives/AddEquipmentModel' :
								'/Archives/UpdateEquipmentModel'),
							param
						).then(res => {
							console.log(res)
							if (res.data.Code == 0) {
								_this.$Message.info("设备型号" + (type == 'add' ? '增加' : '修改') + "成功");
								// _this.$refs.sonPage.getList();
								_this.$refs.table.getData();
								_this.modalView = false;
								_this.PictureDelCache = [];
								_this.GetTypeListDefine()
							} else {
								_this.$Message.info("设备型号" + (type == 'add' ? '增加' : '修改') + "失败:" + res.data.Data);
							}
						})
					}
				})
			},
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}

	.seflPoing .ivu-form-item-label:before {
		content: '*';
		display: inline-block;
		margin-right: 4px;
		line-height: 1;
		font-family: SimSun;
		font-size: 12px;
		color: #ed4014;
	}
</style>